import { Moon, Sun } from 'lucide-react'
import { useTranslation } from 'react-i18next'

import { useColorScheme } from '@/shared/hooks/use-color-scheme'
import { useUiStore } from '@/shared/stores/ui-store'
import { Button } from '@/shared/ui/button'

/**
 * Flips between the light and dark palettes from the top bar.
 *
 * Flips whatever is painted, so from `system` it lands on the explicit opposite;
 * settings is where `system` is chosen again. Both icons render, and the `.dark`
 * class cross-fades them.
 */
export function ThemeToggle() {
  const { t } = useTranslation()
  const scheme = useColorScheme()
  const setTheme = useUiStore((state) => state.setTheme)

  return (
    <Button
      variant="ghost"
      size="icon"
      aria-label={t('action.toggleTheme')}
      onClick={() => setTheme(scheme === 'dark' ? 'light' : 'dark')}
      className="relative shrink-0 rounded-full text-muted-foreground hover:text-foreground"
    >
      <Sun className="rotate-0 scale-100 transition-all dark:-rotate-90 dark:scale-0" />
      <Moon className="absolute rotate-90 scale-0 transition-all dark:rotate-0 dark:scale-100" />
    </Button>
  )
}
